import React from "react";
import { Helmet } from "react-helmet-async";

const normalizeJsonLd = (value) => {
  if (!value) return "";
  try {
    return JSON.stringify(JSON.parse(value)).replace(/</g, "\\u003c");
  } catch (error) {
    console.error("Invalid global JSON-LD was not rendered:", error.message);
    return "";
  }
};

const GlobalSchema = ({ schema }) => {
  if (!schema) return null;

  const organizationSchema = normalizeJsonLd(
    schema.organization_schema || schema.organisation_schema
  );
  const reviewSchema = normalizeJsonLd(schema.review_schema);
  const additionalSchemas = (Array.isArray(schema.additional_schemas) ? schema.additional_schemas : [])
    .map((item) => ({ label: item?.label || "", schema: normalizeJsonLd(item?.schema) }))
    .filter((item) => item.schema);

  const hasGlobalMeta = Boolean(
    schema.twitter_site || schema.twitter_card || schema.twitter_creator || schema.og_site_name
  );
  if (!organizationSchema && !reviewSchema && !additionalSchemas.length && !hasGlobalMeta) return null;

  return (
    <Helmet>
      {schema.og_site_name && <meta property="og:site_name" content={schema.og_site_name} />}
      {schema.twitter_card && <meta name="twitter:card" content={schema.twitter_card} />}
      {schema.twitter_site && <meta name="twitter:site" content={schema.twitter_site} />}
      {schema.twitter_creator && <meta name="twitter:creator" content={schema.twitter_creator} />}
      {organizationSchema && (
        <script id="global-organization-schema" type="application/ld+json">
          {organizationSchema}
        </script>
      )}
      {reviewSchema && (
        <script id="global-review-schema" type="application/ld+json">
          {reviewSchema}
        </script>
      )}
      {additionalSchemas.map((item, index) => (
        <script key={`global-${item.label || "schema"}-${index}`} type="application/ld+json"
          data-schema-label={item.label || undefined} data-schema-scope="global">
          {item.schema}
        </script>
      ))}
    </Helmet>
  );
};

export default GlobalSchema;
